// İSG uzmanı portalı — Risk seviye → token'lı ısı sınıfı eşlemesi (TEK KAYNAK). Hem seviye
// rozeti (RiskLevelBadge) hem 5x5 matris hücresi (MatrixSelect) buradan beslenir — duplike
// yok. Literal renk YOK; sınıflar tokens.css `--color-risk-*` ısı skalasına bağlıdır (AA).
//
// Onemsiz=koyu yeşil, Dusuk=açık yeşil, Orta=sarı, Yuksek=turuncu, KabulEdilemez=kırmızı
// (owner review B1 item 2, 2026-09-28 — önceki Dusuk mavisi kaldırıldı, dördü de tek
// yeşil→sarı→turuncu→kırmızı ailesinde; bkz. tokens.css'in kendi yorumu).

import type { RiskLevel } from '@isgportal/shared';

/** Seviye → dolu zemin + sabit metin (rozet + matris hücresi ortak). */
export const RISK_LEVEL_CLASS: Record<RiskLevel, string> = {
  Onemsiz: 'bg-risk-negligible text-risk-negligible-fg',
  Dusuk: 'bg-risk-low text-risk-low-fg',
  Orta: 'bg-risk-medium text-risk-medium-fg',
  Yuksek: 'bg-risk-high text-risk-high-fg',
  KabulEdilemez: 'bg-risk-unacceptable text-risk-unacceptable-fg',
};
